import { createContext,useContext  } from "react";
export const  AutoDeviceButtonContext = createContext();
export function useAutoDeviceButtonContext() {
    return useContext(AutoDeviceButtonContext);
}

